<template>
  <div
    :class="[
      'h-100',
      'module-section-card',
      'font_Montserrat',
      'd-flex',
      'flex-column',
      'p-3',
      'justify-content-between',
      'align-items',
      'position-relative',
      { 
        clickable: status === $options.status.SUCCESS && !isCompleted,
        disabled,
      },
    ]"
    v-b-tooltip.html="{ title: section.description, disabled: !section.description }"
    @click="onCardClick"
  >
    <div class="d-flex align-items-center text-break justify-content-center">
      <div
        class="font_Montserrat font_size_875rem v3_color_teal letter_spacing_1 text-uppercase text-center"
      >
        {{ section.title }}
      </div>
    </div>
    <div
      class="mt-3 v3_color_black_knight font_size_1000rem"
      :class="[{ 'pr-4': isCompleted }]"
      v-if="status === $options.status.SUCCESS"
    >
      <strong>Status: </strong>
      <span>
        <template v-if="isCompleted">Completed</template>
        <template v-else-if="completionPercent > 0">
          {{ completionPercent }}% completed
        </template>
        <template v-else-if="completionPercent === 0">Not Started</template>
      </span>
      <i
        v-if="status === $options.status.SUCCESS && isCompleted"
        class="mdi mdi-chart-bar complete-module-icon clickable v3_color_teal"
        aria-hidden="true"
        v-b-tooltip.hover
        title="View the module and gain insights in Inform."
        @click.stop="onCompleteIconClick"
      />
    </div>
    <template v-else-if="status === $options.status.PENDING">Pending</template>
    <!-- <b-spinner
      v-else-if="status === $options.status.PENDING"
      small
      class="ml-3"
    /> -->
  </div>
</template>

<script>
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

const STATUS = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
};

export default {
  name: 'ModuleSectionCard',
  props: {
    section: {
      type: Object,
      required: true,
    },
    studyId: [Number, String],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      questions_completed: 0,
      questions_total: 0,
      status: STATUS.PENDING,
    };
  },
  status: STATUS,
  created: function () {
    if (this.studyId)
      this.getSectionStatistics();
  },
  computed: {
    completionPercent: function () {
      if (!this.questions_completed || !this.questions_total) return 0;
      const result = Math.round(
        (this.questions_completed / this.questions_total) * 100
      );
      if (isNaN(result)) return 0;
      return result;
    },
    isCompleted: function () {
      return (
        this.questions_completed > 0 &&
        this.questions_completed === this.questions_total
      );
    },
  },
  methods: {
    getSectionStatistics: async function () {
      this.status = STATUS.PENDING;
      try {
        const {
          questions_completed,
          questions_total,
        } = await Api.getStudySectionStatics(this.studyId, this.section.id);
        this.questions_completed = questions_completed;
        this.questions_total = questions_total;
        this.status = STATUS.SUCCESS;
      } catch (error) {
        this.status = STATUS.ERROR;
        handleServerErrorWithValidation(error, this.$toasted);
      }
    },
    onCardClick: function () {
      if (this.status !== STATUS.SUCCESS || this.isCompleted || this.disabled) return;
      this.$router.push(`/surveyForm/${this.studyId}/${this.section.id}`);
    },
    onCompleteIconClick: function () {
      this.$router.push(
        `/user/filters/${this.section.questionnaire_id}/${this.section.id}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/v3';
.module-section-card {
  min-height: 120px;
  border: 1px solid $v3_color_teal;
  .complete-module-icon {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
  &.disabled {
    cursor: not-allowed;
  }
}
</style>
